export default {
  tooltipTitle: {
    id: 'pdp_historical_price_tooltip_title',
    defaultMessage:
      'What is the average historical completed sale price over the past 90 days?',
  },
  tooltipContent: {
    id: 'pdp_historical_price_tooltip',
    defaultMessage:
      'The "average historical completed sale price over the past 90 days" is calculated based on the prices paid for items with the exact same specifications on this site during the 90-day period ending yesterday. This average is calculated for each specific combination of model, condition (grade), battery option, capacity, and color. Discounts applied via promotional codes are excluded from the calculation. The average is updated daily and is displayed only when there have been at least three purchases within the 90-day period. The percentage by which the current price falls below this average (the comparison value) is displayed in 1% increments, with any decimal fraction truncated.',
  },
  tooltipAriaLabel: {
    id: 'pdp_historical_price_tooltip_aria_label',
    defaultMessage:
      'More information about the average historical completed sale price',
  },
  caption: {
    id: 'pdp_historical_price_caption',
    defaultMessage:
      'Average historical completed sale price over the past 90 days: {referencePrice}',
  },
}
